import {
  Component,
  ElementRef,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { ModalController, AlertController, ToastController } from '@ionic/angular';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { BankService } from 'src/app/services/bank/bank.service';
import { UploadDocument, classApprovalbody } from 'src/app/core/model/application.model';
import { CommonService } from 'src/app/services/common/common.service';
import { ApplicationService } from 'src/app/services/application/application.service';
import { InvestorPayments } from 'src/app/core/model/payment.model';
import { Errors, validationType } from '../../core/model/error.model';

@Component({
  selector: 'app-commitment-approval',
  templateUrl: './commitment-approval.component.html',
  styleUrls: ['./commitment-approval.component.scss'],
})
export class CommitmentApprovalComponent implements OnInit {
  paymentStatus: boolean = false;
  @ViewChildren('fileInput') fileInputs: QueryList<
    ElementRef<HTMLInputElement>
  >;
  @Input() applicationDetails: any;
  fileAttr: string = 'Choose file';
  error = Errors;
  paymentForm = this.fb.group({
    payments: this.fb.array([]),
  });
  holderForm: FormGroup;
  showLoader = false;
  headerText = '';
  url: string = '';
  messageText = '';
  investorname = "";
  commitmentamount = "";
  encrytedAppID = "";
  class = "";
  formid = "";
  isError: boolean = false;
  isDocUploaded: boolean = false;
  fileformatError: boolean = false;
  fileformatErrorPNG: boolean = false;
  maxSizError: boolean = false;
  isDocumentVisible = false;
  documentUrl: string | null = null;
  document: File | null = null;
  objDocumentList: any = [];
  uploadedDocuments: { name: any, content: any, documentType: any }[] = [];
  constructor(
    private modalController: ModalController,
    private fb: FormBuilder,
    private bankService: BankService,
    private sanitizer: DomSanitizer,
    private commonService: CommonService,
    private applicationService: ApplicationService,
    private readonly toastController: ToastController,
    private alertController: AlertController,
  ) { }

  ngOnInit() {
    this.binddata();
    this.getApplicationDocuments();

    //console.log(test);
    this.createForm();
  }

  get form() {
    return this.holderForm.controls;
  }

  createForm() {
    this.holderForm = new FormGroup({
      comments: new FormControl('', [Validators.required]),
      documentUpload: new FormControl('', [Validators.required]),
    });
  }

  binddata() {
    this.formid = this.applicationDetails.formId;
    if (this.applicationDetails.typeOfInvestor == "Individual") {
      this.investorname = this.applicationDetails.firstName + " " + (this.applicationDetails.middleName == null ? " " : this.applicationDetails.middleName) + " " + (this.applicationDetails.middleName == null ? " " : this.applicationDetails.lastName);

    }
    else {
      this.investorname = this.applicationDetails.entityName;
    }
    if (this.applicationDetails.isTopUp == 1) {
      this.class = this.applicationDetails.tp_Class;
      // this.commitmentamount = this.applicationDetails.tp_CommitmentAmount;
      this.commitmentamount = this.commonService.commaSeparateNumber(this.applicationDetails.tp_CommitmentAmount);
    }
    else {
      this.class = this.applicationDetails.class;
      // this.commitmentamount = this.applicationDetails.commitmentAmount;
      this.commitmentamount = this.commonService.commaSeparateNumber(this.applicationDetails.commitmentAmount);
    }
  }



  submit(status: string) {
    this.isError = false;
    this.isDocUploaded = false;

    var test = this.applicationDetails;

    var comments = this.holderForm.controls.comments.value;
    this.form.comments.setValidators(validationType.Required);
    this.form.comments.updateValueAndValidity();
    console.log(comments);
    if (status.toLowerCase() == "reject" && (comments == "" || comments == null || comments == undefined)) {
      this.isError = true;
      return;
    }
    if (this.objDocumentList.length == 0) {
      this.isDocUploaded = true;
      return;
    }
    else {
      this.isDocUploaded = false;
    }

    //return;

    this.showLoader = true;
    this.commonService
      .encrypt(this.applicationDetails.investmentId)
      .subscribe((res: any) => {
        var encryptedText = res.encryptedText
          .replaceAll('/', 'slh')
          .replaceAll('--', '==')
          .replaceAll('-', '=');

        this.encrytedAppID = encryptedText;
        var test = encryptedText;

        var req = {} as classApprovalbody;

        req.comment = comments;
        req.aaplicationuidd = encryptedText;
        req.status = status;

        this.applicationService
          .setCommitmentApproval(req)
          .subscribe(
            async (res: any) => {
              this.showLoader = true;

              var message = "";
              if (status == "Approved") {
                message = "Commitment Approval done";
              }
              else {
                message = "Application is rejected due to incorrect Commitment.";
              }

              const toast = await this.toastController.create({
                message: message,
                duration: 5000,
              });

              toast.present();
              this.dismissModal();

            },
            async (err) => {
              this.commonService.updateLoader(false);
              const toast = await this.toastController.create({
                message: err.error.message,
                duration: 2000,
              });
              toast.present();
              this.dismissModal();
              // this.router.navigateByUrl('/dashboard/0');
            }
          );

      });

  }

  async presentToast(message: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 2000,
    });
    toast.present();
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  uploadDocument() {
    var selectedFile =
      this.fileInputs['_results'][0].nativeElement.files[0];
    var idxDot = selectedFile ? selectedFile.name.lastIndexOf('.') + 1 : null;
    var extFile = selectedFile
      ? selectedFile.name.substr(idxDot, selectedFile.name.length).toLowerCase()
      : null;

    if (
      extFile === 'jpg' ||
      extFile === 'jpeg' ||
      extFile === 'png' ||
      extFile === 'pdf' ||
      extFile === 'msg'
    ) {
      this.fileformatError = false;
    } else {
      this.fileformatError = true;
      return;
    }
    if (
      this.fileInputs['_results'][0].nativeElement.files[0].size > 20000000
    ) {
      this.maxSizError = true;
      return;
    } else {
      this.maxSizError = false;
    }

    this.commonService
      .encrypt(this.applicationDetails.investmentId)
      .subscribe((res: any) => {
        var encryptedText = res.encryptedText
          .replaceAll('/', 'slh')
          .replaceAll('--', '==')
          .replaceAll('-', '=');

        this.encrytedAppID = encryptedText;
        var investorId = this.encrytedAppID;
        const body = {} as UploadDocument;
        body.documentType = "Commitement Approval Document";
        body.applicationUuid = investorId;
        body.isCommitmentApproval = "1";
        //  return;
        this.applicationService.uploadDocument(this.fileInputs['_results'][0].nativeElement.files[0], body).subscribe(
          async (res: any) => {
            this.commonService.updateLoader(false);
            const toast = await this.toastController.create({
              message: "Document uploaded successfully",
              duration: 10000,
            });
            toast.present();
            this.getApplicationDocuments();
          },
          async (err) => {
            this.commonService.updateLoader(false);
            const toast = await this.toastController.create({
              message: err.error.message,
              duration: 2000,
            });
            toast.present();
          }
        );
      });
  }

  viewDocument(doc: { content: any, documentType: string }) {
    let documentUrl: SafeUrl;
    if (doc.content instanceof File) {
      const blob = new Blob([doc.content], { type: doc.content.type });
      documentUrl = URL.createObjectURL(blob);
    } else {
      documentUrl = doc.content;
    }
    window.open(documentUrl as string, '_blank');
  }


  getApplicationDocuments() {
    let bodyload = {} as any;
    bodyload.investmentId = (this.applicationDetails.investmentId).toString();
    bodyload.documenttype = "Commitement Approval Document";
    bodyload.groupId = "";
    bodyload.applicationType = "Fresh";
    console.log(bodyload);
    this.applicationService.getApplicationDocuments(bodyload).subscribe({
      next: async (res: any) => {
        console.log(res);
        //var mydata = JSON.parse(res.data);
        var mydata = res.data;
        console.log(mydata);
        this.objDocumentList = mydata;

      },
      error: async (err) => {
        this.commonService.updateLoader(false);

      },
    });

  }

  viewFile(doc) {

    this.commonService.encrypt(this.applicationDetails.investmentId).subscribe((res: any) => {
      var uuid = res.encryptedText.replaceAll('/', 'slh').replaceAll('==', '--').replaceAll('=', '-');
      // body.isCommitmentApproval = isCommitmentApproval;
      this.applicationService.downloadDocument(doc.documentType, "", uuid, doc.fileName, "0", "1").subscribe(
        (res: any) => {
          this.commonService.updateLoader(false);
          const docUrl = `${res.message}`;
          window.open(docUrl, '_blank');
        },
        (err) => {
          this.commonService.updateLoader(false);
        }
      );
    });

  }



  async deleteDocument(fileName: string, documentid: number) {
    // this.isMandatory =false;
    const alert = await this.alertController.create({
      header: 'Confirm!',
      message: `Are you sure you want to delete this document ?`,
      buttons: [
        {
          text: 'No',
          handler: () => { },
        },
        {
          text: 'Yes',
          handler: () => {
            this.applicationService
              .deleteDocument(documentid, fileName)
              .subscribe({
                next: async (res) => {
                  this.getApplicationDocuments();
                  const toast = await this.toastController.create({
                    message: `Document ${fileName} deleted successfully.`,
                    duration: 2000,
                  });
                  toast.present();
                },
              });
          },
        },
      ],
    });

    await alert.present();
  }



}
